var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Announcement-List" },
    [
      _c(
        "div",
        { staticClass: "List-header" },
        [
          _vm.$hasBtnPermiss("AnnouncementAddData").isShow
            ? _c(
                "el-button",
                {
                  staticClass: "addButton",
                  attrs: {
                    icon: "el-icon-plus",
                    type: "primary",
                    size: "small"
                  },
                  on: { click: _vm.handelAddBtn }
                },
                [_vm._v("新增")]
              )
            : _vm._e(),
          _vm.$hasBtnPermiss("AnnouncementDeleteMoreData").isShow
            ? _c(
                "el-button",
                {
                  staticClass: "delButton",
                  attrs: {
                    icon: "el-icon-close",
                    type: "danger",
                    size: "small"
                  },
                  on: { click: _vm.handelDelBtn }
                },
                [_vm._v("批量删除")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.formHead.TYPE_ID,
            callback: function($$v) {
              _vm.$set(_vm.formHead, "TYPE_ID", $$v)
            },
            expression: "formHead.TYPE_ID"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "公司公告", name: "1" } }),
          _c("el-tab-pane", { attrs: { label: "供应商须知", name: "2" } })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "MesTable-wrap" },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              attrs: {
                border: "",
                align: "center",
                height: "auto",
                data: _vm.mainData,
                "column-config": _vm.columnConfig,
                "show-overflow": "",
                "row-config": { isHover: true, height: 55 },
                size: "small"
              },
              on: {
                "checkbox-all": _vm.selectAllEvent,
                "checkbox-change": _vm.selectChangeEvent
              }
            },
            [
              _vm._v(" > "),
              _c("vxe-column", { attrs: { type: "checkbox", width: "60" } }),
              _c("vxe-column", {
                attrs: { field: "CODE", width: "150", title: "单据编号" }
              }),
              _c("vxe-column", {
                attrs: {
                  field: "TYPE_ID",
                  width: "120",
                  title: "发布方式",
                  formatter: _vm.formatterType
                }
              }),
              _c("vxe-column", {
                attrs: { field: "ISSUE_DATE", width: "150", title: "日期" }
              }),
              _c("vxe-column", {
                attrs: { field: "THEME", width: "150", title: "公告主题" }
              }),
              _c("vxe-column", {
                attrs: {
                  field: "simpleCONTENT",
                  width: "150",
                  title: "公告内容"
                }
              }),
              _c("vxe-column", {
                attrs: { field: "FILE_CODE", width: "120", title: "文档编号" }
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTACHMENT_URL",
                  width: "250",
                  title: "附件地址"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTACHMENT_NAME",
                  width: "150",
                  title: "附件文件名"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  field: "IS_SHOW_INDEX",
                  width: "120",
                  title: "是否在首页显示",
                  formatter: _vm.formatterShow
                }
              }),
              _c("vxe-column", {
                attrs: { title: "操作", fixed: "right", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "operation-wrap" },
                          [
                            _vm.$hasBtnPermiss("DataShow").isShow
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkNotice(row)
                                      }
                                    }
                                  },
                                  [_vm._v("查看")]
                                )
                              : _vm._e(),
                            _vm.$hasBtnPermiss("EditShow").isShow
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "warning" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editNotice(row)
                                      }
                                    }
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            _vm.$hasBtnPermiss("AnnouncementDeleteData").isShow
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.delNotice(row)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "公告信息",
                visible: _vm.dialogVisible,
                width: "60%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "dialogContent",
                  staticStyle: { "margin-bottom": "25px" }
                },
                [
                  _c("span", [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("单据编号：")
                    ]),
                    _vm._v(" " + _vm._s(_vm.dialogContent.CODE) + " ")
                  ]),
                  _c("span", [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("发布方式：")
                    ]),
                    _vm._v(
                      _vm._s(
                        _vm.dialogContent.TYPE_ID == "1"
                          ? "公司公告"
                          : "供应商须知"
                      )
                    )
                  ]),
                  _c("span", [
                    _c("span", { staticClass: "title" }, [_vm._v("日期：")]),
                    _vm._v(_vm._s(_vm.dialogContent.ISSUE_DATE))
                  ]),
                  _c("span", [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("公告主题：")
                    ]),
                    _vm._v(_vm._s(_vm.dialogContent.THEME))
                  ])
                ]
              ),
              _c("div", { staticClass: "dialogContent" }, [
                _c("span", [
                  _c("span", { staticClass: "title" }, [_vm._v("公告内容：")]),
                  _vm._v(_vm._s(_vm.dialogContent.simpleCONTENT))
                ]),
                _c("span", [
                  _c("span", { staticClass: "title" }, [_vm._v("附件地址：")]),
                  _vm._v(_vm._s(_vm.dialogContent.ATTACHMENT_URL))
                ]),
                _c("span", [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("附件文件名：")
                  ]),
                  _vm._v(_vm._s(_vm.dialogContent.ATTACHMENT_NAME))
                ]),
                _c("span", [
                  _c("span", { staticClass: "title" }, [_vm._v("文档编号：")]),
                  _vm._v(_vm._s(_vm.dialogContent.FILE_CODE))
                ]),
                _c("span", [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("是否在首页显示：")
                  ]),
                  _vm._v(
                    _vm._s(_vm.dialogContent.IS_SHOW_INDEX == "1" ? "是" : "否")
                  )
                ])
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm.$hasBtnPermiss("EditShow").isShow
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.editNotice(_vm.row)
                            }
                          }
                        },
                        [_vm._v("编 辑")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-warp" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next",
              total: _vm.TableData.TotalCount,
              "page-sizes": [10, 20, 30, 50],
              "current-page": _vm.TableData.PageIndex
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }